import { compile } from 'vue/dist/vue.esm-bundler'

export default defineNuxtPlugin({
    name: 'icons',
    parallel: true,
    async setup(nuxtApp) {
        const icons = import.meta.glob('~/icons/*.svg', {
            as: 'raw',
            eager: true,
        })

        const getIconName = (name) => {
            name = name.replace('/icons/', '').replace('.svg', '').replace('-m', '').replace('(', '').replace(')', '').replace('+', '').replace(/ /g, '-').split('-')

            for (let a = 0; a < name.length; a++) {
                name[a] = name[a][0].toUpperCase() + name[a].substr(1)
            }

            return 'Icon' + name.join('')
        }

        let added = []
        let name,
            component = null

        for (let i in icons) {
            name = getIconName(i)
            component = icons[i]

            if (added.indexOf(name) !== -1) {
                continue
            }

            nuxtApp.vueApp.component(name, compile(component))

            added.push(name)
        }

        nuxtApp.provide('icon', {
            name: (icon) => {
                return getIconName(icon)
            },
        })
    },
})
